export const mapCummulatedObject = (
  element: any,
  key: any,
  week: any,
  parentKey: string,
  spreadEqualMeasures: Array<string>,
  lowHeirarichyMeasures: Array<string>
) => {
  element[parentKey][key] =
    key.indexOf('Comment') > -1 || spreadEqualMeasures.includes(key)
      ? element[parentKey][key]
      : +element[parentKey][key].toString().replaceAll(',', '');
  if (lowHeirarichyMeasures.includes(key)) {
    element[parentKey][key] = week[parentKey][key];
  } else if (spreadEqualMeasures.includes(key)) {
    if (key.indexOf('Pct') > 0) {
      element[parentKey][key] = week[parentKey][key];
    } else {
      element[parentKey][key] =
        element[parentKey][key] > week[parentKey][key]
          ? element[parentKey][key]
          : week[parentKey][key];
    }
  } else if (key.indexOf('Comment') < 0 && key.indexOf('Pct') < 0) {
    element[parentKey][key] += +(week[parentKey][key] || 0)
      .toString()
      .replaceAll(',', '');
    element[parentKey][key] = Math.round(Number(element[parentKey][key]));
  } else if (key.indexOf('Comment') > 0) {
    element[parentKey][key] = week[parentKey][key];
  }
  if (
    key == 'AccountEndingonHandInventory' ||
    key == 'DistiEndingonHandInventory'
  ) {
    if (new Date() >= new Date(week.title)) {
      element[parentKey][key] = week[parentKey][key];
    }
  }
};
export const mapCummulatedObjectAg = (
  element: any,
  key: any,
  week: any,
  parentKey: string,
  spreadEqualMeasures: Array<string>,
  lowHeirarichyMeasures: Array<string>,
  multipleAggregatedMeasures?: Array<string>,
) => {
  if (
    element[parentKey][key] === undefined ||
    element[parentKey][key] === null
  ) {
    return;
  }
  element[parentKey][key] = key.indexOf('Comment') > -1 || spreadEqualMeasures.includes(key) ? element[parentKey][key] : element[parentKey][key];
  if (lowHeirarichyMeasures.includes(key) || multipleAggregatedMeasures?.includes(key)) {
    element[parentKey][key] = week[parentKey][key];
  } else if (spreadEqualMeasures.includes(key)) {
    if (key.indexOf('Pct') > 0) {
      element[parentKey][key] = week[parentKey][key];
    } else {
      element[parentKey][key] = element[parentKey][key] > week[parentKey][key] ? element[parentKey][key]: week[parentKey][key];
    }
  } else if (key.indexOf('Comment') < 0 && key.indexOf('Pct') < 0) {
    element[parentKey][key] += +(week[parentKey][key] || 0);
    // element[parentKey][key] = Math.round(Number(element[parentKey][key]));
    element[parentKey][key] = Number(element[parentKey][key]);
  } else if (key.indexOf('Comment') > 0) {
    element[parentKey][key] = week[parentKey][key];
  }
  if (
    key == 'AccountEndingonHandInventory' ||
    key == 'DistiEndingonHandInventory'
  ) {
    if (new Date() >= new Date(week.title)) {
      element[parentKey][key] = week[parentKey][key];
    }
  }
};


